import { addAlpha, getColorForString } from '../utils';

type Props = {
    resource: { title: string; extendedProps: { doc: { personal: { pic?: string } } } };
    size?: number;
};

const ResourceAvatar: React.FC<Props> = ({ resource, size = 28 }) => {
    return resource.extendedProps?.doc?.personal?.pic ? (
        <div style={{ width: size, height: size }}>
            <img
                src={resource.extendedProps.doc.personal.pic}
                style={{ width: size, height: size }}
                className="rounded-64"
            />
        </div>
    ) : (
        <div
            className="flex items-center justify-center leading-6 text-20 font-700 rounded-64"
            style={{
                width: size,
                height: size,
                color: getColorForString(resource.title + 'random'),
                backgroundColor: addAlpha(getColorForString(resource.title), 0.1),
            }}
        >
            {resource.title[0]}
        </div>
    );
};

export default ResourceAvatar;
